export enum IconType {
  projects = 'projects',
  clients = 'clients',
  members = 'members',
  clientReport = 'client-report',
  employeeReport = 'employee-report',
  policies = 'policies',
  holidays = 'holidays',
  requests = 'requests',
}